// eslint-disable-next-line import/prefer-default-export
export const validateGroupName = ({ value }: any): boolean => (value ? value.length <= 45 : true);
export const validationKeyName = ({ value }: any): boolean => (value ? value.length <= 255 : true);
export const validateUserId = (user: any): boolean => !!(user && user.id);
